<template>
  <div class="INFO -moto-version-update">
    <div class="-info-box">
      <div class="-message">
        <span class="-text"> System received improvements! </span>
        <wt-button
          class="-action-button"
          type="hollow-light"
          text="Refresh"
          @click="$_refresh"
        />
      </div>
    </div>
    <slot name="closeItemSlot" :closeItem="closeItem" />
  </div>
</template>

<script>
import CommonMessageInterface from 'v/notification/CommonMessageInterface.vue';

export default CommonMessageInterface.extend({
  name: 'MotoVersionUpdate',

  methods: {
    $_refresh() {
      window.location.reload();
    },
  },
});
</script>

<style lang="scss">
.wt2-notification-feedback > .-item.-moto-version-update {
  .-message {
    display: flex;
    align-content: center;

    .-text {
      flex-grow: 1;
      align-self: center;
      text-align: center;
      font-size: 20px;
    }

    .-action-button {
      height: 36px;
      width: 64px;
      margin-right: 2rem;
    }
  }
}
</style>
